import { render } from "./index.vue?vue&type=template&id=47a17cfc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=47a17cfc&lang=scss&scoped=true"

import exportComponent from "C:\\D\\work\\zhenbo\\code\\pay\\pay_all\\pay_admin_page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a17cfc"]])

export default __exports__